;(() => {
    if (window.__verdellaCartDrawerReady) return;
    window.__verdellaCartDrawerReady = true;

    const shell = document.querySelector('[data-vd-cart-shell]');
    if (!shell) return;
    const body = shell.querySelector('[data-vd-cart-body]');
    const footer = shell.querySelector('[data-vd-cart-footer]');
    const total = shell.querySelector('[data-vd-cart-total]');
    const shipping = shell.querySelector('[data-vd-cart-shipping]');
    const status = shell.querySelector('[data-vd-cart-status]');
    const error = shell.querySelector('[data-vd-cart-error]');
    const countEls = document.querySelectorAll('[data-vd-cart-count]');
    const productUrl = '/products/verdella-mini-produce-cleaner';
    let returnFocus = null;

    const money = (cents) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format((Number(cents) || 0) / 100);
    const esc = (value) => String(value || '').replace(/[&<>'"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[char]));

    const openDrawer = () => {
      returnFocus = document.activeElement;
      shell.hidden = false;
      document.body.classList.add('vd-cart-open');
      window.requestAnimationFrame(() => shell.querySelector('[data-vd-cart-close]')?.focus());
    };

    const closeDrawer = () => {
      shell.hidden = true;
      document.body.classList.remove('vd-cart-open');
      returnFocus?.focus?.();
    };

    const renderCart = (cart, preferredItem, justAdded) => {
      countEls.forEach((el) => { el.textContent = cart.item_count; });
      error.hidden = true;
      error.textContent = '';
      status.textContent = justAdded ? '✓ Added to your cart' : '';

      if (!cart.items || !cart.items.length) {
        body.innerHTML = '<div><p class="vd-cart__empty">Your cart is empty.</p><a class="vd-cart__empty-link" href="' + productUrl + '">Shop Verdella Mini</a></div>';
        footer.hidden = true;
        return;
      }

      const item = (preferredItem && cart.items.find((line) => line.key === preferredItem.key || line.variant_id === preferredItem.variant_id)) || cart.items[0];
      const image = item.image || (item.featured_image && item.featured_image.url) || '';
      body.innerHTML = '<article class="vd-cart__item">' +
        (image ? '<img class="vd-cart__image" src="' + esc(image) + '" alt="' + esc(item.product_title) + '">' : '<div class="vd-cart__image"></div>') +
        '<div><h3>' + esc(item.product_title) + '</h3><p class="vd-cart__variant">' + esc(item.variant_title || '') + '</p><p class="vd-cart__price">' + money(item.final_line_price || item.line_price) + '</p><div class="vd-cart__quantity" aria-label="Quantity"><button type="button" aria-label="Decrease quantity" data-vd-quantity-change data-line-key="' + esc(item.key) + '" data-quantity="' + Math.max(0, item.quantity - 1) + '">−</button><span aria-live="polite">' + item.quantity + '</span><button type="button" aria-label="Increase quantity" data-vd-quantity-change data-line-key="' + esc(item.key) + '" data-quantity="' + (item.quantity + 1) + '">+</button></div></div></article>';
      total.textContent = money(cart.total_price);
      const hasFreeShippingPack = cart.items.some((line) => line.sku === 'VER-MINI-2' || line.sku === 'VER-MINI-3');
      shipping.textContent = hasFreeShippingPack ? '✓ Free shipping included on your multi-pack' : 'Shipping calculated at checkout';
      footer.hidden = false;
    };

    const loadCart = async (preferredItem, justAdded) => {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Cart could not be loaded.');
      const cart = await response.json();
      renderCart(cart, preferredItem, justAdded);
      return cart;
    };

    document.addEventListener('click', async (event) => {
      const quantityButton = event.target.closest('[data-vd-quantity-change]');
      if (quantityButton) {
        event.preventDefault();
        quantityButton.disabled = true;
        error.hidden = true;
        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              id: quantityButton.dataset.lineKey,
              quantity: Number(quantityButton.dataset.quantity)
            })
          });
          const updatedCart = await response.json();
          if (!response.ok) throw new Error(updatedCart.description || 'The quantity could not be updated.');
          renderCart(updatedCart, null, false);
        } catch (quantityError) {
          error.textContent = quantityError.message || 'The quantity could not be updated.';
          error.hidden = false;
          quantityButton.disabled = false;
        }
        return;
      }

      const opener = event.target.closest('[data-vd-cart-open]');
      if (opener) {
        event.preventDefault();
        openDrawer();
        body.innerHTML = '<p class="vd-cart__loading">Loading your cart…</p>';
        footer.hidden = true;
        try { await loadCart(null, false); }
        catch (loadError) { error.textContent = loadError.message; error.hidden = false; }
        return;
      }
      if (event.target.closest('[data-vd-cart-close]')) closeDrawer();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !shell.hidden) closeDrawer();
    });

    document.addEventListener('submit', async (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || form.getAttribute('id') !== 'verdella-product-form') return;
      event.preventDefault();

      const idInput = form.querySelector('[name="id"]');
      const submitButton = event.submitter || form.querySelector('[type="submit"]');
      if (!idInput?.value) return;

      const originalText = submitButton?.innerHTML;
      if (submitButton) { submitButton.disabled = true; submitButton.textContent = 'Adding…'; }
      error.hidden = true;

      try {
        const addResponse = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] })
        });
        const added = await addResponse.json();
        if (!addResponse.ok) throw new Error(added.description || 'This item could not be added.');
        const addedItem = added.items ? added.items[0] : added;
        openDrawer();
        body.innerHTML = '<p class="vd-cart__loading">Updating your cart…</p>';
        footer.hidden = true;
        await loadCart(addedItem, true);
      } catch (addError) {
        openDrawer();
        error.textContent = addError.message || 'Something went wrong. Please try again.';
        error.hidden = false;
      } finally {
        if (submitButton) { submitButton.disabled = false; submitButton.innerHTML = originalText; }
      }
    });
  })();